import { Link } from 'react-router-dom'
import type { Crumb } from '../../lib/seo'

/** Visual breadcrumb trail (mirrors the BreadcrumbList JSON-LD). */
export default function Breadcrumbs({ crumbs }: { crumbs: Crumb[] }) {
  return (
    <nav aria-label="Breadcrumb" className="text-[0.85rem] text-ink-soft mb-6">
      <ol className="flex flex-wrap items-center gap-2">
        {crumbs.map((c, i) => {
          const last = i === crumbs.length - 1
          return (
            <li key={c.path} className="flex items-center gap-2">
              {last ? (
                <span className="text-ink" aria-current="page">
                  {c.name}
                </span>
              ) : (
                <Link to={c.path} className="hover:text-ink transition">
                  {c.name}
                </Link>
              )}
              {!last && <span className="text-ink-soft/50">/</span>}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
